import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="w-full bg-black text-white py-10 px-4 md:px-8 text-center" data-id="element-65">
      <div className="max-w-3xl mx-auto" data-id="element-66">
        <ShieldCheckIcon className="w-16 h-16 text-yellow-400 mx-auto mb-4" data-id="element-67" />

        <h2 className="text-3xl md:text-4xl font-bold mb-4 text-yellow-400" data-id="element-68">
          Garantía de Satisfacción Total
        </h2>

        <p className="text-xl md:text-2xl leading-relaxed" data-id="element-69">
          Probalo 7 días. Si no cumple tus expectativas, te devolvemos el 100%.{' '}
          <br data-id="element-70" />
          <span className="font-bold text-white" data-id="element-71">Sin preguntas.</span>
        </p>
      </div>
    </section>;
}